import { DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReportHtmlWrapper = styled.div`
  position: relative;

  &:after {
    content: '';
    width: 15px;
    height: 100%;
    border-radius: ${DefaultValue.BorderRadius};
    position: absolute;
    top: 0;
    right: 0;
  }

  .export-document {
    overflow: auto; /* for wider reports we add the scroll */
  }
`
